import { useState } from "react";
import { Button } from "@mui/material";
import UploadFile from "@mui/icons-material/UploadFile";
import InsertDriveFileOutlined from "@mui/icons-material/InsertDriveFileOutlined";
import CloseOutlined from "@mui/icons-material/CloseOutlined";
import UploadModal, { ErrorableFileState, processFileUploadErrorStates } from "components/UploadModal/UploadModal";
import { UploadViewWrapper } from "components/UploadView/uploadView.styles";
import { formatBytes } from "utils/file";
import { FileDuplicateText, FileIncorrectTypeText } from "constants/text";
import * as Styles from "../pages/SupportCasePage.styles";

interface SupportCaseAttachmentsProps {
	files: File[];
	onChange: (files: File[]) => void;
	disabled: boolean;
}

const SupportCaseAttachments = ({ files, onChange, disabled }: SupportCaseAttachmentsProps) => {
	const [open, setOpen] = useState(false);
	const validateFile = (file: File, maxMB: number) => {
		if (files.some((existing) => existing.name === file.name)) return FileDuplicateText;
		if (!/\.(jpe?g|png|pdf)$/i.test(file.name)) return FileIncorrectTypeText;
		return processFileUploadErrorStates(file, maxMB);
	};
	const handleClose = (selected: ErrorableFileState[]) => {
		const nextFiles = [...files];
		selected.forEach(({ file, error }) => {
			if (!error && !validateFile(file, 10) && !nextFiles.some((existing) => existing.name === file.name)) {
				nextFiles.push(file);
			}
		});
		onChange(nextFiles);
		setOpen(false);
	};

	return (
		<>
			<Button
				variant="outlined"
				type="button"
				fullWidth
				disabled={disabled}
				startIcon={<UploadFile />}
				onClick={() => setOpen(true)}
			>
				ATTACH FILE
			</Button>
			<Styles.HelpText>
				Supported Files: JPG, JPEG, PNG, PDF
				<br />
				Max File Size: 10MB per image
			</Styles.HelpText>
			<div aria-label="Attached files">
				{files.map((file, index) => (
					<UploadViewWrapper key={file.name}>
						<div>
							<InsertDriveFileOutlined aria-hidden="true" />
							<div>
								<p>{file.name}</p>
								<p>{formatBytes(file.size)}</p>
							</div>
						</div>
						<button
							type="button"
							disabled={disabled}
							aria-label={`Remove ${file.name}`}
							onClick={() => onChange(files.filter((_, i) => i !== index))}
						>
							<CloseOutlined />
						</button>
					</UploadViewWrapper>
				))}
			</div>
			<UploadModal
				open={open}
				handleClose={handleClose}
				item={null}
				maxFiles={Infinity}
				fileSelectionText={null}
				dragDropAcceptedFileTypes=".jpg,.jpeg,.png,.pdf"
				checkIsValidFile={(file) => !validateFile(file, 10)}
				handleUploadErrorStates={validateFile}
			/>
		</>
	);
};

export default SupportCaseAttachments;
